import { kSpacingAdjElementType } from "../constants";
import { PAddZoomControl } from "./PAddZoomControl";
import { QSpacingControl } from "../CoreApp/QSpacingControl";
import { QSpacingText } from "../CoreApp/QSpacingText";

export function AddSpacingControl(
  x,
  y,
  startVal,
  minusCmd,
  plusCmd,
  controlType,
  resetCmd,
  entercmd,
  adder,
  parentPanel,
  min,
  max,
  uiColors
) {
  var sC = new QSpacingControl();
  sC.SetMinMax(min, max);
  sC.fMinus = PAddZoomControl(x, y - 2, false, null, minusCmd, parentPanel, true);

  x += 20;
  var sT = new QSpacingText();
  sT.InitSpacingText(startVal);
  sT.PositionElement(x, y);
  sT.SizeElement(30, 12);
  parentPanel.PushElement(sT);
  sT.SetCmdCode(entercmd);
  sC.fValueText = sT;
  sT.SetElementType(kSpacingAdjElementType);
  sT["parentctrl"] = sC;
  sC.fResetCmd = resetCmd;

  if (uiColors) {
    sT.SetTextColor(uiColors.GetHeaderTextColor());
    sT.SetFillColor(uiColors.GetTextEditFillColor());
    sT.SetBorderColor(uiColors.GetTextEditBorderColor());
  }

  x += 33;
  sC.fPlus = PAddZoomControl(x, y - 2, true, null, plusCmd, parentPanel, true);

  sC.SetAdder(adder);
  sC.EnableControls();

  return sC;
}
